// extracted by mini-css-extract-plugin
export default {"passwordInput":"passwordCreateForm-module__passwordInput__YMhYB"};